import { render, staticRenderFns } from "./testeCamera3.vue?vue&type=template&id=b8658290&"
import script from "./testeCamera3.vue?vue&type=script&lang=js&"
export * from "./testeCamera3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports